import type { AuthUser } from '@/hooks/useGetCurrentUser/types'
import type { NotAuthorizedSearchSchema } from '@/routes/schemas'

export function getNotAuthorizedSearch(
  user: Pick<AuthUser, 'isDashboardOnly'> | undefined,
  initiativeId?: string | number
): NotAuthorizedSearchSchema {
  if (user == null || initiativeId == null) return {}

  const id = Number(initiativeId)
  return user.isDashboardOnly(id) ? { initiativeId: id } : {}
}

export function parseNotAuthorizedSearch(
  search: Record<string, unknown>
): NotAuthorizedSearchSchema {
  const initiativeId = Number(search.initiativeId)
  return Number.isSafeInteger(initiativeId) && initiativeId >= 1
    ? { initiativeId }
    : {}
}
